import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { useFormContext } from 'react-hook-form';

const DealLeadEmailField = () => {
    const { control, watch } = useFormContext();
    const { leadId } = watch();

    return (
        <FormField
            control={control}
            name="email"
            render={({ field }) => (
                <FormItem>
                    <FormLabel className="mb-2 block text-[10.5px] font-medium uppercase tracking-[0.12em] text-slate-500">
                        Lead Email <span className="text-accent-red">*</span>
                    </FormLabel>
                    <FormControl>
                        <Input
                            readOnly={!!leadId}
                            placeholder="Enter lead email"
                            {...field}
                            type="email"
                            className="h-10 rounded-xl border-white/[0.06] bg-white/[0.02] px-3 text-[12.5px] text-slate-200 placeholder:text-slate-500 focus:border-brand-500/40 focus-visible:ring-0 focus-visible:ring-offset-0 read-only:opacity-60"
                        />
                    </FormControl>
                    <FormMessage className="text-[10.5px] text-accent-red" />
                </FormItem>
            )}
        />
    );
};

export default DealLeadEmailField;
